export const unexpectedLiteErrorMessage = "Unexpected error. Please try again."
export const notValidCodeMessage = "This is not a valid code."
